<template>
    <sys-teacher-hub-modal
        :show="show"
        @update:show="$emit('update:show', $event)"
        :title="title"
        icon="mdi-book-open-page-variant-outline"
    >
        <v-card-text class="pa-4">
            <sys-teacher-attribution-table
                :teacher="teacher"
                :work-time="workTime"
                :token="token"
                hide-register
            />
        </v-card-text>
    </sys-teacher-hub-modal>
</template>

<script>
export default {
    name: 'SysTeacherMyClassesHub',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        teacher: {
            type: Object,
            required: true
        },
        workTime: {
            type: Object,
            required: true
        },
        token: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: 'Minhas Aulas'
        }
    }
}
</script>
